export default {"src":"/_next/static/media/setting-goals-archery.mono.d4fa6546.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};